<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute">
        <img class="box-img" src="../assets/banner2.png" />
        <div class="box-font">网上竞价</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px">
      <div style="display: flex; margin-top: 40px">
        <div>
          <leftmenu :value="type" :list="Tender_menulist" @datashow="listshow"></leftmenu>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div style="margin-left: 20px; width: 100%; border: 1px solid #cccccc">
          <div style="width: 100%; height: 90px; justify-content: center; display: flex; padding-top: 30px" v-if="type != 3">
            <input
              id="zb_title"
              type="text"
              value=""
              placeholder="请输入关键词（招标编号或项目名称）"
              style="text-indent: 10px; width: 400px; height: 42px; border-radius: 5px 0px 0px 5px; border: 1px solid #df3e3e"
            />
            <a
              @click="searchzb_title()"
              style="
                background-color: #df3e3e;
                color: #ffffff;
                width: 100px;
                height: 42px;
                border-radius: 0px 5px 5px 0px;
                text-align: center;
                padding-top: 10px;
              "
              >搜索</a
            >
          </div>
          <div style="width: 100%; height: 90px; justify-content: center; display: flex; padding-top: 30px" v-else>
            <input
              id="zb_title"
              type="text"
              value=""
              placeholder="请输入关键词（标题）"
              style="text-indent: 10px; width: 400px; height: 42px; border-radius: 5px 0px 0px 5px; border: 1px solid #df3e3e"
            />
            <a
              @click="searchzb_title()"
              style="
                background-color: #df3e3e;
                color: #ffffff;
                width: 100px;
                height: 42px;
                border-radius: 0px 5px 5px 0px;
                text-align: center;
                padding-top: 10px;
              "
              >搜索</a
            >
          </div>
          <el-table
            v-show="type == 1"
            :data="this.tenderslist"
            style="width: 100%; font-size: 18px"
            :row-style="{}"
            :cell-style="{ 'font-size': '16px', padding: '20px 0px' }"
            :header-row-style="{}"
            :fit="true"
          >
            <el-table-column prop="Title" label="招标编号" width="200"> </el-table-column>
            <el-table-column prop="Name" label="招标项目" min-width="160">
              <template slot-scope="scope">
                <router-link :to="'/Tenderdetail?id=' + scope.row.Id">{{ scope.row.Name }}</router-link>
              </template>
            </el-table-column>
            <el-table-column prop="BBeginTime" label="报名开始时间" width="170"> </el-table-column>
            <el-table-column prop="JBeginTime" label="竞价开始时间" width="170"> </el-table-column>
            <!-- <el-table-column prop="JEndTime" label="竞价截止时间" width="170">
            </el-table-column> -->
          </el-table>
          <el-table
            v-show="type == 2"
            :data="this.tenderslist"
            style="width: 100%; font-size: 18px"
            :row-style="{}"
            :cell-style="{ 'font-size': '16px', padding: '20px 0px' }"
            :header-row-style="{}"
            :fit="true"
          >
            <el-table-column prop="Subtitle" label="招标编号"> </el-table-column>
            <el-table-column prop="Title" label="招标项目">
              <template slot-scope="scope">
                <router-link :to="'/ResultNotice?id=' + scope.row.Id" target="_blank">{{ scope.row.Title }}</router-link>
              </template>
            </el-table-column>
            <el-table-column prop="PublishTime" label="发布时间"> </el-table-column>
          </el-table>
          <el-table
            v-show="type == 3"
            :data="this.tenderslist"
            style="width: 100%; font-size: 18px"
            :row-style="{}"
            :cell-style="{ 'font-size': '16px', padding: '20px 0px' }"
            :header-row-style="{}"
            :fit="true"
          >
            <el-table-column prop="Title" label="标题">
              <template slot-scope="scope">
                <router-link :to="'/ResultbcNotice?id=' + scope.row.Id" target="_blank">{{ scope.row.Title }}</router-link>
              </template>
            </el-table-column>
            <el-table-column prop="PublishTime" label="发布时间"> </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 15, 20]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "Tender",
  components: { leftmenu, leftlogin },
  data() {
    return {
      isShow: true,
      tenderslist: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      Tender_menulist: [
        {
          Word_Text: "竞价公告",
          Id: 1,
          Word_Value: 1,
        },
        {
          Word_Text: "补充公告",
          Id: 3,
          Word_Value: 3,
        },
        {
          Word_Text: "结果公告",
          Id: 2,
          Word_Value: 2,
        },
      ],
      type: "",
      form: {
        name: "",
        pass: "",
        type: "",
      },
      search: "",
    };
  },
  created() {
    var that = this;
    that.type = that.$route.query.id;
    that.search = that.$route.query.search;
    if (that.type) {
      var list = that.Tender_menulist.filter(function (item) {
        return item.Word_Value == that.type;
      });
      if (list.length > 0) {
        if (that.type == 2) that.getResultNotice();
        else if (that.type == 3) that.getbcNotice();
        else that.getData();
      }
    } else that.listshow(that.Tender_menulist[0]);
  },
  methods: {
    getData() {
      var that = this;
      var params = {
        PageIndex: that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: "Id desc",
        // Title: that.search,
        // Name: that.search,
        Multiple: that.search,
      };
      that.$api.get("/Tender/Get", params, (r) => {
        that.tenderslist = r.response.data.filter((x) => x.Status == 1);
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    getResultNotice() {
      var that = this;
      var params = {
        PageIndex: that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: "p.Id desc",
        // Title: that.search,
        // Subtitle: that.search
        Multiple: that.search,
      };
      that.$api.get("/ResultNotice/GetList", params, (r) => {
        that.tenderslist = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    getbcNotice() {
      var that = this;
      var params = {
        PageIndex: that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: "Id desc",
        // Title: that.search,
        // Subtitle: that.search
        Multiple: that.search,
      };
      that.$api.get("/supplyNotice/Get", params, (r) => {
        that.tenderslist = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(size) {
      this.pagesize = size;
      if (this.type == 2) this.getResultNotice();
      else if (this.type == 3) that.getbcNotice();
      else this.getData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      if (this.type == 2) this.getResultNotice();
      else if (this.type == 3) that.getbcNotice();
      else this.getData();
    },
    listshow(item) {
      var that = this;
      that.search = "";
      var inputelement = document.getElementById("zb_title");
      if (inputelement) {
        inputelement.value = "";
      }
      that.currentPage = 1;
      that.type = item.Word_Value;
      if (that.type == 2) that.getResultNotice();
      else if (that.type == 3) that.getbcNotice();
      else that.getData();
      return false;
    },
    searchzb_title() {
      this.search = document.getElementById("zb_title").value;
      if (this.type == 2) this.getResultNotice();
      else if (this.type == 3) this.getbcNotice();
      else this.getData();
    },
  },
  watch: {
    $route(to) {
      var that = this;
      that.type = to.query.id;
      that.search = to.query.search;
      if (that.type) {
        var list = that.Tender_menulist.filter(function (item) {
          return item.Word_Value == that.type;
        });
        if (list.length > 0) {
          if (that.type == 2) that.getResultNotice();
          else if (that.type == 3) that.getbcNotice();
          else that.getData();
        }
      } else that.listshow(that.Tender_menulist[0]);
    },
  },
  computed: {},
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #eeeeee;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}
</style>
